module.exports = __webpack_public_path__ + "static/tutor-screen@0.5x-fbdf6605399511e6c4258274af15ee6d.png";